var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"card medium:flex p-4"},[_c('div',{staticClass:"medium:flex-1"},[_c('h3',{staticClass:"text-xl hidden medium:block",class:{
          'mb-2': _vm.$slots.default
      }},[_vm._v(_vm._s(_vm.props.title))]),(_vm.$slots.default)?_c('div',{staticClass:"text-center medium:text-left"},[_vm._t("default")],2):_vm._e(),_c('h3',{staticClass:"text-xl text-center block medium:hidden",class:{
          'border-50 border-t pt-4 mt-4': _vm.$slots.default,
          'border-50 border-b pb-4 mb-4': _vm.$slots.badges,
      }},[_vm._v(_vm._s(_vm.props.title))])]),(_vm.$slots.badges)?_c('div',{staticClass:"text-center medium:text-right"},[_vm._t("badges")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }